export const FOOTER_NAV = [
  { typo: '이용약관', url: '/tos' },
  { typo: '개인정보 처리방침', url: '/privacy-policy' },
]
export const MOBILET_HEADER_NAV = [
  { typo: '마이페이지', url: '/mypage' },
  { typo: '이용약관', url: '/tos' },
  { typo: '개인정보 처리방침', url: '/privacy-policy' },
]
